const sizes = {
    "18": "4.5rem",
};
export default sizes;
